export default "__VITE_ASSET__BcRt2X6f__"